import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { Text } from './styles';
export * from './styles';
const Typography = forwardRef(({ id, type, lineHeight, color, children, fontSize, className, fontFamily, treatAs, as = 'span', testId = 'text', forcedFontLanguage, }, ref) => {
    const { colors } = useTheme();
    const colorToApply = color || colors.text.default;
    return (_jsx(Text, { id: id, ref: ref, as: treatAs || as, type: type, color: colorToApply, "data-cy": testId, "data-testid": testId, lineHeight: lineHeight, fontSize: fontSize, className: className, fontFamily: fontFamily, forcedFontLanguage: forcedFontLanguage, children: children }));
});
Typography.displayName = 'Typography';
export default Typography;
//# sourceMappingURL=Typography.js.map